import { styled } from '@mui/material';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  creditsHistoryAgGridStyle: 'creditsHistoryAgGridStyle',
};

export const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.creditsHistoryAgGridStyle}`]: {
    [up('xs')]: {
      height: '50vh',
    },
    [up('sm')]: {
      height: '62vh',
    },
    [up('md')]: {
      height: '61vh',
    },
    [up('lg')]: {
      height: '65vh',
    },
    [up('xl')]: {
      height: '74vh',
    },
    [up('xxl')]: {
      height: '76vh',
    },
  },
}));
